<template>
  <div class="page-container base-batch-list">
    <div class="page-title-container">
      <h1 class="page-title">Esquemas</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre, período o estado"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'celulares-schemes-create' }"
                  variant="none"
                  v-if="$can('manage', 'esquema_agregar')"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Nombre</span>
            </div>

            <div>
              <span>Aplicación</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{
                    name: 'celulares-schemes-edit',
                    params: { id: o.id },
                  }"
                  class="mr-2"
                  v-if="$can('manage', 'esquema_editar')"
                  >Editar</router-link
                >

                <router-link
                  :to="{
                    name: 'celulares-schemes-details',
                    params: { id: o.id },
                  }"
                  v-if="$can('manage', 'esquema_detalle')"
                  class="mr-2"
                  >Ver detalle</router-link
                >

                <router-link
                  :to="{
                    name: 'celulares-schemes-winners-details',
                    params: { id: o.id },
                  }"
                  v-if="$can('manage', 'esquema_ganadores')"
                  class="mr-2"
                  >Ver ganadores</router-link
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Período:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Ciclo:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Fecha de Inicio:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Fecha de Fin:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Creado por:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Aplicación</th>
              <th>Período</th>
              <th>Ciclo</th>
              <th>Fecha de <br> Inicio</th>
              <th>Fecha de <br> Fin</th>
              <th>Creado por</th>
              <th>Estado</th>
              <th class="pr-md-3"
                  v-if="$can('manage', 'esquema_editar') ||
                    $can('manage', 'esquema_activar') ||
                    $can('manage', 'esquema_detalle') ||
                    $can('manage', 'esquema_ganadores')">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center px-1"></td>
              <td class="cell-center"></td>
              <td class="cell-center"></td>
              <td class="cell-center"></td>
              <td class="cell-center"></td>
              <td class="cell-center">
              </td>
              <td class="cell-center d_option pr-md-2 position-relative"
                  v-if="$can('manage', 'esquema_editar') ||
                    $can('manage', 'esquema_activar') ||
                    $can('manage', 'esquema_detalle') ||
                    $can('manage', 'esquema_ganadores')">
                <DropdownTable>
                  <template v-slot:dropdown-content>
                    <DropdownItem
                      text="Editar"
                      v-if="$can('manage', 'esquema_editar')"
                      :to="{
                        name: 'celulares-schemes-edit',
                        params: { id: o.id },
                      }"
                    />
                    <DropdownItem
                      text="Ver detalle"
                      v-if="$can('manage', 'esquema_detalle')"
                      :to="{
                        name: 'celulares-schemes-details',
                        params: { id: o.id },
                      }"
                    />
                    <DropdownItem
                      text="Ver ganadores"
                      v-if="$can('manage', 'esquema_ganadores')"
                      :to="{
                        name: 'celulares-schemes-winners-details',
                        params: { id: o.id },
                      }"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados que coincidan con los criterios seleccionados.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SchemeService } from "../../Core/Services";

import {
  Alert,
  Constants,
  DropdownItem,
  DropdownTable,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  Util,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";

export default {
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu
  },
  data() {
    return {
      list: [],
      tooltipType: null,
      pageSize: 100,
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.SchemeStatus.ACTIVE,
            LocalConstants.SchemeStatus.INACTIVE,
          ]
        }
      ],
    };
  },
  mixins: [FilterMixin, PaginationMixin],
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "period,desc",
        };

        const data = { search: this.search, ...this.filters };
        const response = await SchemeService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    download(asset) {
      if (asset) Util.downloadFile(asset.url, asset.name);
    },
  },
  async mounted() {
    // await this.loadData();
  },
  async created() {},
};
</script>

<style lang="stylus" scoped></style>
